import React, { useEffect, useState } from 'react';

/* Client "Tools" SSO landing page (2026-08-03).
 *
 * The trading application redirects the client's browser to:
 *   GET /api/auth/sso?ucc=...&ts=...&sig=...
 * Our backend (routes/auth.js) verifies that, then 302-redirects the
 * browser here, to:
 *   /sso-landing?token=...&ucc=...&name=...&mobile=...&email=...
 *
 * This component's only job is to take those query params, store them in
 * localStorage using the EXACT SAME keys (`nb_token`, `nb_client`) and the
 * EXACT SAME client-object shape ({name, ucc, mobile, email, dob}) that
 * App.jsx's handleLoginSuccess() already writes after a normal OTP login,
 * then force a full-page reload to `/`. That reload hits App.jsx's
 * existing client-bootstrap useEffect (the same code path that already
 * restores a session after a plain page refresh) -- so from that point on
 * this is indistinguishable from a normal OTP login. No change to that
 * bootstrap logic, Dashboard, or square-off flag gating was needed.
 *
 * Mirrors the existing `/dealer-client` route's pattern (DealerClientView
 * "handles its own auth") already established in App.jsx -- same idea,
 * applied to the client side instead of the dealer side.
 */
export default function ClientSSOLanding() {
  const [status, setStatus] = useState('logging_in'); // 'logging_in' | 'error'

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const token  = params.get('token');
    const ucc    = params.get('ucc')    || '';
    const name   = params.get('name')   || '';
    const mobile = params.get('mobile') || '';
    const email  = params.get('email')  || '';

    if (!token || !ucc) {
      setStatus('error');
      return;
    }

    try {
      localStorage.setItem('nb_token', token);
      localStorage.setItem('nb_client', JSON.stringify({
        name, ucc, mobile, email, dob: ''
      }));
      // Full reload (not client-side state update) -- lands on '/' and lets
      // App.jsx's existing bootstrap useEffect pick the session up exactly
      // as it would after any normal page refresh post-login.
      window.location.href = '/';
    } catch {
      setStatus('error');
    }
  }, []);

  if (status === 'error') {
    return (
      <div style={{
        minHeight: '100vh', display: 'flex', flexDirection: 'column',
        alignItems: 'center', justifyContent: 'center',
        fontFamily: "'DM Sans',-apple-system,sans-serif", padding: 24, textAlign: 'center'
      }}>
        <div style={{ fontSize: 15, fontWeight: 600, color: '#0f172a', marginBottom: 8 }}>
          This login link is invalid or has expired.
        </div>
        <div style={{ fontSize: 13, color: '#64748b', marginBottom: 20 }}>
          Please go back to the trading application and try again from Tools.
        </div>
        <button
          onClick={() => { window.location.href = '/'; }}
          style={{
            background: '#2563eb', color: '#fff', border: 'none',
            borderRadius: 6, padding: '8px 18px', fontSize: 13, fontWeight: 600, cursor: 'pointer'
          }}
        >
          Go to login
        </button>
      </div>
    );
  }

  return (
    <div style={{
      minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center',
      fontFamily: "'DM Sans',-apple-system,sans-serif", fontSize: 13, color: '#64748b'
    }}>
      Logging you in…
    </div>
  );
}